// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"5f470ddf","453":"dff87da4","985":"a0bd8437"}[chunkId] + ".chunk.js";
};